// Third party modules;
import React from 'react';

// HelpBot modules;
import app from './app';
import { Form, form_close } from './Form';

const IntegrateApplication = () => {

   const build = async ({ set_body, set_foot, ...args }) => {
      // The build() function sets the body and foot componenets and waits for the user to 
      // initiate an action on the form such as an option select, text input or submit;

      set_body(
         <div className="ask-henry-body-margin-bottom-x">
           <p className="ask-henry-body-margin-bottom-x">To integerate the {app.name} wizard into your application, put the following code fragment some where in your web page:</p>
           <p className="ask-henry-body-margin-bottom-x ask-henry-form-integrate-application-script">&lt;script defer="" id="research-helpbot-script" slug="{app.state.user_access_list[app.state.user_access_id].application_name.toLowerCase()}" src="{app.host}/research-helpbot.js" type="text/javascript">&lt;/script></p>
         </div>
      );

      set_foot(
         <>
           <button className="ask-henry-form-button" onClick={form_close} >Close</button>
         </>
      );

   } // build();

   return <Form build={build} class_string="ask-henry-form-integrate-application" title={'Integrate Application' + app.who()} />

} // <IntegrateApplication />;

export default IntegrateApplication;
